var map = {
	"./Bind_Status_Icon.png": 17665,
	"./Burn_Status_Icon.png": 49787,
	"./Confusion_Status_Icon.png": 28952,
	"./Cursed_Status_Icon.png": 97422,
	"./Demotivated_Status_Icon.png": 92418,
	"./Frail_Status_Icon.png": 13434,
	"./Freeze_Status_Icon.png": 65453,
	"./Hex_Status_Icon.png": 94251,
	"./Inception_Status_Icon.png": 34853,
	"./Leech_Status_Icon.png": 94839,
	"./Nervous_Status_Icon.png": 52654,
	"./Paralyze_Status_Icon.png": 95080,
	"./Planted_Status_Icon.png": 82820,
	"./Poison_Status_Icon.png": 8352,
	"./Provoked_Status_Icon.png": 1336,
	"./Puzzled_Status_Icon.png": 20680,
	"./Recover_Status_Icon.png": 84084,
	"./Sick_Status_Icon.png": 92706,
	"./Sleep_Status_Icon.png": 77205,
	"./Survive_Status_Icon.png": 37062
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39377;